
// JS
import '../../custom/js/custom/index';

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';

// Components
import '../../custom/scss/custom/components/breadcrumb/breadcrumb.scss';
import '../../custom/scss/common/components/hero/hero.scss';
import '../../custom/scss/custom/components/hero/hero.scss';
import '../../custom/scss/custom/components/sitemap/sitemap.scss';